import React, { createContext, useState, useContext, useEffect } from 'react';

interface AnimationsContextType {
  animationsEnabled: boolean;
  toggleAnimations: () => void;
}

export const AnimationsContext = createContext<AnimationsContextType>({
  animationsEnabled: true,
  toggleAnimations: () => {},
});

export const useAnimations = () => useContext(AnimationsContext);

interface AnimationsProviderProps {
  children: React.ReactNode;
}

export const AnimationsProvider: React.FC<AnimationsProviderProps> = ({ children }) => {
  // Load animation preference from localStorage
  const [animationsEnabled, setAnimationsEnabled] = useState<boolean>(() => {
    const stored = localStorage.getItem('animationsEnabled');
    return stored !== null ? stored === 'true' : true; // Default to enabled
  });

  // Save to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('animationsEnabled', String(animationsEnabled));
  }, [animationsEnabled]);

  const toggleAnimations = () => {
    setAnimationsEnabled((prev) => !prev);
  };

  return (
    <AnimationsContext.Provider value={{ animationsEnabled, toggleAnimations }}>
      {children}
    </AnimationsContext.Provider>
  );
};
